import extender from 'extends-classes';

/**
 * @deprecated
 * @param traits
 * @constructor
 */
export function Mixin(...traits: any[]) {
    return extender(...traits);
}

/**
 * @deprecated
 * @param class$
 * @param traits
 * @constructor
 */
export function Mix(class$, ...traits: any[]) {
    traits.forEach((trait) => {
        Object.getOwnPropertyNames(trait.prototype).forEach((prop) => {
            if (prop !== 'constructor') {
                if (class$.WrappedComponent) {
                    class$.WrappedComponent.prototype[prop] = trait.prototype[prop];
                } else {
                    class$.prototype[prop] = trait.prototype[prop];
                }
            }
        });
    });

    return class$;
}
